export default __webpack_public_path__ + "static/media/Download.174156d0.svg";